module.exports = __webpack_public_path__ + "img/q8.6668ac90.gif";